import { AccordionEnhancedWrapper } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { translationClasses } from '@/shared/TranslationClasses';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { CreateC36AccordionEnhancedModel } from './C36AccordionEnhanced.service';
import { C36AccordionEnhancedProps } from './C36AccordionEnhanced.types';
import { useCustomSitecoreContext } from '@/shared/useCustomSitecoreContext';
import { PromptForUnavailableInTheme } from '@/shared/PromptForUnavailableInTheme';

const Default = (props?: C36AccordionEnhancedProps) => {
  const { rendering, params } = props || {};
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const model = CreateC36AccordionEnhancedModel(props);
  const context = useCustomSitecoreContext();

  const marketingRenderingName = useCreateMarketingRenderingHame(
    rendering?.componentName as string
  );

  if (context?.siteTheme?.value !== 'WakeForest')
    return (
      <PromptForUnavailableInTheme
        siteTheme={context?.siteTheme?.value ?? ''}
        componentName={rendering?.componentName}
      />
    );

  return (
    <AccordionEnhancedWrapper
      className={translationClasses(params)}
      id={params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...model}
      type={isEditing ? 'multiple' : model.type}
      shouldOpenAllItems={!!isEditing}
    />
  );
};

export default checkDatasourceForRendering<C36AccordionEnhancedProps>(Default);
